import { render, staticRenderFns } from "./SaveProductConfigurationButton.vue?vue&type=template&id=7d74c8a0&"
import script from "./SaveProductConfigurationButton.vue?vue&type=script&lang=js&"
export * from "./SaveProductConfigurationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports